





































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningRequestFormCreateV2 from "@/components/learning-request-v2/LearningRequestFormCreateV2.vue";
import { learningRequestApi } from "@/getinfo-api";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import {
  LearningRequestCreate as ILearningRequestCreate,
  LearningRequest as ILearningRequest
} from "@/api-v2/learning-requests/models";
import { Student as IStudent } from "@/api-v2/course/models/student";
import registrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { cloneDeep } from "lodash";
import { nextSequence } from "@/utils/generate-helper";

@Component({ components: { CPageButtons, LearningRequestFormCreateV2, CPage } })
export default class LearningRequestCreateV2 extends Vue {
  learningRequestForm!: ILearningRequestCreate;
  learningRequest!: ILearningRequest;
  students!: IStudent[];
  isLoading: boolean = false;
  isSaving: boolean = false;

  data() {
    return {
      learningRequest: undefined,
      learningRequestForm: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: `${this.$tc(this.$translate.LearningRequests)}`
      },
      {
        to: {
          name: "learningRequest",
          params: { id: this.learningRequest.id }
        },
        label: this.learningRequest.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async getLearningRequest() {
    await learningRequestApi.Request.getRequest(this.$route.params.id).then(
      res => {
        this.learningRequest = res.data;
        this.learningRequest.price = this.$converter.getPrice(res.data.price);
      }
    );
  }

  async getRegistrations(params: CourseRegistrationsListParams) {
    await registrations(params).then(res => {
      this.learningRequestForm = {
        //@ts-ignore
        studentIds: res.data.items.map(el => el.student.id),
        ...this.learningRequest
      };
      this.students = res.data.items.map(el => el.student);
    });
  }

  async editLearningRequest() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    let form = cloneDeep(this.learningRequestForm);
    form.price = this.$converter.setPrice(form.price);
    this.isSaving = true;
    learningRequestApi.Request.editRequest(this.$route.params.id, form)
      .then(async res => {
        await nextSequence();
        await this.$router.push({
          name: "learningRequest",
          params: {
            id: res.data.id
          }
        });
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  removeLearningRequest() {
    learningRequestApi.Request.deleteRequest(this.$route.params.id).then(() => {
      this.$router.push({
        name: "orders"
      });
    });
  }

  back() {
    this.$router.push({
      name: "learningRequest",
      params: { id: this.$route.params.id }
    });
  }

  async init() {
    this.isLoading = true;
    await this.getLearningRequest();
    let params: CourseRegistrationsListParams = {
      ids: this.learningRequest.registrationIds
    };
    await this.getRegistrations(params);
    this.isLoading = false;
  }

  created() {
    this.init();
  }
}
